import { isAndroid } from 'react-device-detect';
import ReactPlayer from 'react-player/lib';

// android 開啟 playsinline，避免 android 在 LINE 中無法播放的問題。
// 原本設在 _app.js 的全域 defaultProps，會把 react-player 釘進每頁共用 chunk;
// 移到此 wrapper 後，react-player 只在實際播放影片的頁面 chunk 載入。
// (react-player 與 react-player/lib 解析到同一個檔案，defaultProps 為共用 singleton。)
if (isAndroid) {
	(ReactPlayer as any).defaultProps = {
		...(ReactPlayer as any).defaultProps,
		playsinline: true,
	};
}

export default ReactPlayer;
